import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, FormFeedback, FormGroup, FormText, Input, Label, Row, Tooltip, Alert } from 'reactstrap';

export function FieldGroup({
  id,
  label,
  showFeedback = false,
  required = false,
  feedback,
  help,
  lg,
  tooltip,
  ...props
}) {
  const [isOpenTop, setIsOpenTop] = useState(false);
  return (
    <Row>
      <Col sm tag={FormGroup}>
        {label ? (
          <Label>
            {label}
            {required ? <span style={{ color: '#bd472a' }}>*</span> : null}
            {tooltip ? (
              <>
                <span className="ml-2 font-weight-bold border border-dark rounded-circle px-1" id="pop3">
                  ?
                </span>
                {tooltip ? (
                  <Tooltip placement="top" isOpen={isOpenTop} target="pop3" toggle={() => setIsOpenTop(!isOpenTop)}>
                    {tooltip}
                  </Tooltip>
                ) : (
                  ''
                )}
              </>
            ) : null}
          </Label>
        ) : null}
        <Input id={id} {...props} />
        {help && <FormText color="muted">{help}</FormText>}
        <FormFeedback className={showFeedback ? 'd-block' : ''}>
          <Alert color="danger" fade={false}>
            {feedback}
          </Alert>
        </FormFeedback>
      </Col>
    </Row>
  );
}

FieldGroup.propTypes = {
  id: PropTypes.string,
  lg: PropTypes.string,
  label: PropTypes.string,
  help: PropTypes.string,
  feedback: PropTypes.string,
  showFeedback: PropTypes.bool,
  required: PropTypes.bool,
  tooltip: PropTypes.string
};
